import React, { Component } from "react";

import { withAuth } from "../../shared/containers/containerAuth";
import { withSignInForm } from "../../shared/containers/containerSignInForm";

import LoginInput from "../../shared/items/contols/loginInput";

import styles from "./signInForm.module.scss";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { StylesProvider } from "@material-ui/core";

class SignInForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hiddenPassword: true,
    };
  }

  render() {
    const { onHandleChangeStore, signInForm, errors } = this.props;
    const { hiddenPassword } = this.state;

    return (
      <React.Fragment>
        <div className={StylesProvider.login_container}>
          <LoginInput
            name="email"
            type="text"
            store={signInForm.signInItems}
            handleChangeStore={onHandleChangeStore}
            placeholder="Логин"
            errors={errors}
          />
        </div>

        <div className={styles.password_container}>
          <LoginInput
            name="password"
            type={hiddenPassword ? "password" : "text"}
            store={signInForm.signInItems}
            handleChangeStore={onHandleChangeStore}
            placeholder="Пароль"
            errors={errors}
          />
        </div>

        <div className={styles.showPassordIconWraper}>
          <div
            className={styles.showPassordIcon}
            onClick={() => {
              this.setState({ hiddenPassword: !hiddenPassword });
            }}
          >
            {hiddenPassword ? <VisibilityOffIcon fontSize={"small"} /> : <VisibilityIcon fontSize={"small"} />}
          </div>
        </div>

        <div style={{ textAlign: "center" }}>
          <span>
            Забыли пароль?{" "}
            <a className={styles.linkRestore} href="/Accounts/Restore">
              Восстановить
            </a>
          </span>
        </div>
      </React.Fragment>
    );
  }
}

export default withAuth(withSignInForm(SignInForm));
